module.exports = __webpack_public_path__ + "static/img/products discription_Semi-rigid PVC Film2.ad721181.jpg";